import { ProfitAnalysisPage } from "../../_shared/ProfitAnalysisPage";

export default function SpecEditPage() {
  return <ProfitAnalysisPage paType="spec" mode="edit" />;
}
